<p-dialog
  [header]="'deactivation.confirm_title' | translate"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '400px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="!isLoading"
  [appendTo]="'body'"
  [baseZIndex]="deactivationDialogBaseZIndex"
>
  <div class="flex items-start mb-4 mt-2">
    <i class="pi pi-exclamation-triangle text-red-500 text-2xl mr-3"></i>
    <span>{{ 'deactivation.confirm_body' | translate }}</span>
  </div>

  <div
    *ngIf="unsyncedItems.length"
    class="mb-4 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700"
  >
    <div class="mb-2 flex items-start gap-2">
      <i class="pi pi-exclamation-triangle text-red-600 mt-0.5"></i>
      <div>
        <div class="font-medium text-red-800">
          {{ 'deactivation.unsynced_detail_title' | translate }}
        </div>
        <div *ngIf="deactivationErrorMessage" class="mt-1">
          {{ deactivationErrorMessage }}
        </div>
      </div>
    </div>

    <div class="grid gap-2">
      <div
        *ngFor="let item of unsyncedItems"
        class="flex items-center justify-between rounded border border-red-100 bg-white px-3 py-2"
      >
        <span class="font-medium text-red-800">{{ item.typeLabel }}</span>
        <span class="font-semibold text-red-700">{{ item.count }}</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'common.cancel' | translate"
      icon="pi pi-times"
      (onClick)="hide()"
      [text]="true"
      [disabled]="isLoading"
    ></p-button>
    <p-button
      [label]="'deactivation.agree' | translate"
      icon="pi pi-check"
      severity="danger"
      (onClick)="onDeactivate()"
      [loading]="isLoading"
      [appDisableWithoutPermission]="deactivatePermission"
      [appDisableWithoutPermissionBaseDisabled]="isLoading"
    ></p-button>
  </ng-template>
</p-dialog>

<p-toast
  [baseZIndex]="deactivationToastBaseZIndex"
></p-toast>
